"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var fp_1 = require("lodash/fp");
var createHumps_1 = __importDefault(require("./createHumps"));
// Only export the one default. Be friendly to CommonJS.
exports.default = createHumps_1.default(fp_1.camelCase);
exports.createHumps = createHumps_1.default;
//# sourceMappingURL=index.js.map